import { Component, ViewEncapsulation } from '@angular/core';
import { ArticleService } from 'src/app/services/article.service';
import { PATHS } from 'shared/paths';
import { Article } from 'shared/types';
import { Page, Section, SubSection, SubSubsection } from 'shared/location-enums';
import { DiseaseService } from 'src/app/services/disease.service';

@Component({
    selector: 'clinical-trials-contact-us',
    templateUrl: './clinical-trials-contact-us.component.html',
    styleUrls: ['./clinical-trials-contact-us.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ClinicalTrialsContactUsComponent {
    diseaseSearchUrl: string;

    clinicalTrialArticle: Article;
    clinicalTrialButton: Article;

    contactCenter: Article;
    contactArticle: Article;
    imgPathBase = PATHS.assets;

    contactButtonUrl: string;

    constructor(articleService: ArticleService, diseaseService: DiseaseService) {
        this.clinicalTrialArticle = articleService.getOne(Page.about, Section.research, SubSection.clinicalTrialsGov, undefined, undefined, false, SubSubsection.intro);

        this.clinicalTrialButton = articleService.getOne(Page.about, Section.research, SubSection.clinicalTrialsGov, undefined, undefined, false, SubSubsection.button);

        this.contactArticle = articleService.getOne(Page.about, Section.research, SubSection.GARDContactCenter, 1, undefined, false, SubSubsection.intro);

        this.contactCenter = articleService.getOne(Page.all, Section.gardContactCenter, SubSection.contactCenterInfo, undefined, undefined, false);

        this.contactButtonUrl = this.contactCenter.linkUrl ?? '';

        // Get disease service URL
        const currentDiseaseName = diseaseService.disease.name;

        // dynamic compound search term
        let searchTerm: string;

        // split out search terms from compound string
        const synonymsList: string[] = diseaseService.disease.synonymsList.split('; ');
        if (synonymsList.length > 0) {
            const currentDiseaseOtherNames = synonymsList.join('" OR "');
            searchTerm = `${currentDiseaseName} OR "${currentDiseaseOtherNames}"`;
        } else {
            searchTerm = currentDiseaseName;
        }

        // Set the URL for the clinical trials search
        this.diseaseSearchUrl = `https://www.clinicaltrials.gov/ct2/results?cond=${searchTerm}&recrs=b&recrs=a`;
    }
}
